import { Flex, Text } from '@auviknetworks/iceberg-ui';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SearchingApps } from 'application/Shared/Components/App/SearchingApps';
import { Route } from 'application/Shared/Helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

export const QuickScanSearchingAppsStep = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    const navigate = useNavigate();

    const { partnerId } = useParams();
    const basePartnerRoute = Route.buildBasePartnerRoute({ partnerId });

    const onDone = () => {
        navigate(`${basePartnerRoute}/onboarding/quickScan/completed/success`);
    };

    return (
        <Box display="flex" width="100%" justifyContent="center">
            <Flex
                alignItems="center"
                alignSelf="center"
                data-testid="onboardingQuickScanSearchingAppsStep"
                flexDirection="column"
                mt={4}
                px={4}
                width="100%"
                maxWidth="624px" // 560px (figma) + pl (32px) + pr (32px)
            >
                <Text
                    fontSize={['32px', '32px', '32px', 5]}
                    color={theme.palette.onboarding.titleTextColor}
                    fontWeight="600"
                    textAlign="center"
                >
                    {t('Onboarding.quickScanSearchingAppsStep.title')}
                </Text>
                <SearchingApps
                    onDone={onDone}
                    progressBarText={t(
                        'SearchingAppsStep.progressBar.searchApps'
                    )}
                />
            </Flex>
        </Box>
    );
};
